<template>
  <d-navbar-nav class="flex-row" :key="ComponentKey">
    <li class="nav-item border-left border-right dropdown notifications">
      <a
        class="nav-link nav-link-icon text-center"
        v-on:click="ToggleDropdown('notifications-collapse')"
      >
        <div class="nav-link-icon__wrapper">
          <i class="material-icons">&#xE7F4;</i>
          <d-badge pill theme="danger" v-if="TotalUnreadNotifications > 0">{{
            TotalUnreadNotifications
          }}</d-badge>
        </div>
      </a>
      <b-collapse
        id="notifications-collapse"
        class="dropdown-menu dropdown-menu-small"
        v-on:click="ToggleDropdown('notifications-collapse')"
        style="max-height: 405px !important;  overflow-y: scroll;"
      >
        <template v-for="(notification, index) in Notifications">
          <template v-if="!notification.IsRead">
            <b-dropdown-item
              :href="notification.Link"
              v-bind:key="'notification-' + index"
              v-on:click="ToggleDropdown('notifications-collapse')"
            >
              <div class="notification__icon-wrapper">
                <div class="notification__icon">
                  <i class="material-icons">{{ notification.Icon }}</i>
                  <!-- You can find ICONS here https://material.io/resources/icons/ -->
                </div>
              </div>
              <div class="notification__content">
                <span class="notification__category">{{
                  notification.Category
                }}</span>
                <p v-html="notification.Description"></p>
              </div>
            </b-dropdown-item>
          </template>
        </template>
        <d-dropdown-item
          v-if="TotalUnreadNotifications > 0"
          class="notification__all text-center"
          v-on:click="ToggleDropdown('notifications-collapse')"
          v-on:click.stop.native="MarkAllAsReaded"
          >{{
            TotalUnreadNotifications > 1
              ? "Marcar todas como lidas"
              : "Marcar como lida"
          }}</d-dropdown-item
        >
        <d-dropdown-item
          v-else
          style="height: 4rem"
          v-on:click="ToggleDropdown('notifications-collapse')"
          class="notification__all text-center pt-4"
        >
          Nenhuma notificação
          <i class="material-icons">insert_emoticon</i>
        </d-dropdown-item>
      </b-collapse>
    </li>
    <li
      class="nav-item border-left dropdown"
      v-on:click="ToggleDropdown('user-actions-collapse')"
    >
      <a class="nav-link dropdown-toggle text-nowrap px-3">
        <img
          class="user-avatar rounded-circle mr-2"
          id="imgUserNav"
          :src="User.PictureUrl"
          alt="User Avatar"
        />
        <div class="user-info d-inline-block">
          <span class="d-none d-md-block user-name no-select">{{
            User.Name
          }}</span>
          <span class="d-none d-md-block company-name no-select"
            >{{ User.Email }}&nbsp;</span
          >
        </div>
      </a>
      <b-collapse
        id="user-actions-collapse"
        class="dropdown-menu dropdown-menu-small"
      >
        <b-dropdown-item to="/user-profile">
          <i class="material-icons">&#xE7FD;</i> Minha Conta
        </b-dropdown-item>
        <b-dropdown-item to="/change-password">
          <i class="material-icons">&#xe899;</i> Alterar Senha
        </b-dropdown-item>
        <b-dropdown-item
          v-if="
            $isAuthorize('UserInternal', 'UpdateMerchant') ||
            $isAuthorize('UserPartner', 'UpdatePartner')
          "
          to="/change-access"
        >
          <i class="material-icons">vpn_key</i> Alterar Acesso
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item
          href="#"
          class="text-danger"
          :class="[loginOut ? 'text-center' : '']"
          :disabled="loginOut"
          v-on:click.stop="Logoff()"
        >
          <template v-if="!loginOut">
            <i class="material-icons text-danger">&#xE879;</i> Logout
          </template>
          <template v-else>
            Saindo
            <b-spinner class="ml-2" small v-if="loginOut"></b-spinner>
          </template>
        </b-dropdown-item>
      </b-collapse>
    </li>
  </d-navbar-nav>
</template>

<script>
export default {
  name: "NavBarNav",
  data: function () {
    return {
      ComponentKey: 0,
      isFirstClick: null,
      LastOpenedCollapse: null,
      loginOut: false,
      Notifications: [],
      User: {
        Name: "",
        PictureUrl: "",
        Email: "",
      },
    };
  },
  computed: {
    TotalUnreadNotifications() {
      let unreadList = this.Notifications.filter((elm) => {
        return elm.IsRead == false;
      });
      return unreadList.length;
    },
  },
  created() {
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (isJustShown) {
        if (this.LastOpenedCollapse != null) {
          // If there's some colapse opened, close it first.
          this.$root.$emit("bv::toggle::collapse", this.LastOpenedCollapse);
        }
        this.LastOpenedCollapse = collapseId;
        this.isFirstClick = true;
      } else {
        if (this.LastOpenedCollapse == collapseId) {
          this.LastOpenedCollapse = null;
        }
      }
    });

    this.$root.$on("PageClick", () => {
      if (this.LastOpenedCollapse != null && this.isFirstClick == false) {
        this.$root.$emit("bv::toggle::collapse", this.LastOpenedCollapse);
      }
      this.isFirstClick = this.isFirstClick ? false : null;
    });

    this.$root.$on("UpdateUserInfoHeader", () => {
      this.GetUserData();
    });
  },
  mounted() {
    this.GetUserData();
    this.CheckForNotifications();
  },
  methods: {
    CheckForNotifications: function () {
      let markedAsReaded = sessionStorage.getItem("NotificationIsReaded");
      if (markedAsReaded == null || markedAsReaded == "false") {
        this.GetNotificationInternal();
      }
      this.ComponentKey += 1;
    },
    GetNotificationInternal: function () {
      this.$store.dispatch("GetNotificationInternal").then((response) => {
        this.CheckPendingMerchantSolicitation(
          response.TotalItemsPendingMerchantSolicitation
        );
        this.CheckPendingProspectHistory(
          response.TotalItemsPendingProspectHistory
        );
        this.CheckPendingPartner(response.TotalItemsPendingPartner);
        this.CheckPendingPartnerDoc(response.TotalItemsPendingPartnerDoc);
        this.CheckPendingNoteExtractPartner(
          response.TotalItemsPendingNoteExtractPartner
        );
        // this.CheckPendingPartnerSolicitationContract(
        //   response.TotalItemsPendingPartnerSolicitationContract
        // );
        // this.CheckPendingPartnerSignedContract(
        //   response.TotalItemsPendingPartnerSignedContract
        // );
        this.CheckPartnerModifiedIdentity(
          response.TotalItemsPendingPartnerModifiedIdentity
        );
        //this.CheckPendingMerchantSolicitationContract(
          //response.TotalItemsPendingMerchantSolicitationContract
        //);
        // this.CheckPendingMerchantSignedContract(
        //   response.TotalItemsPendingMerchantSignedContract
        // );
        this.CheckChangeManagement(response.TotalItemsChangeManagement);
        // this.CheckAlertaMerchant(response.TotalItemsAlertaMerchant);
      });
    },
    CheckPendingMerchantSolicitation: function (pendingAnalysis) {
      if (
        !this.$isAuthorize("MerchantSolicitation", "List") ||
        !this.$isAuthorize("MerchantSolicitation", "Update")
      )
        return;
      if (pendingAnalysis != null && pendingAnalysis > 0) {
        let wordReq = "solicitações";
        let wordPend = "pendentes";
        if (pendingAnalysis == 1) {
          wordReq = "solicitação";
          wordPend = "pendente";
        }
        this.Notifications.push({
          Category: "Solicitações de Alteração de Parceiro",
          Description: `Há ${pendingAnalysis} ${wordReq} de alteração de parceiro ${wordPend}. Clique nessa notificação para verificar as pendências.`,
          Icon: "fact_check",
          Link: "/relationship/merchant-solicitations?listPending=true",
          IsRead: false,
          IsPermanent: true,
        });
      }
    },
    CheckPendingProspectHistory: function (pendingAnalysis) {
      if (
        !this.$isAuthorize("ProspectHistory", "List") ||
        !this.$isAuthorize("ProspectHistory", "Update")
      )
        return;
      if (pendingAnalysis != null && pendingAnalysis > 0) {
        let wordReq = "solicitações";
        let wordPend = "pendentes";
        if (pendingAnalysis == 1) {
          wordReq = "solicitação";
          wordPend = "pendente";
        }
        this.Notifications.push({
          Category: "Solicitações de Renovação",
          Description: `Há ${pendingAnalysis} ${wordReq} de renovação ${wordPend}. Clique nessa notificação para verificar as pendências.`,
          Icon: "playlist_add_check",
          Link: "/relationship/prospect-histories?listPending=true",
          IsRead: false,
          IsPermanent: true,
        });
      }
    },
    CheckPendingPartner: function (pendingAnalysis) {
      if (
        !this.$isAuthorize("Partner", "List") ||
        !this.$isAuthorize("Partner", "UpdateStatus")
      )
        return;
      if (pendingAnalysis != null && pendingAnalysis > 0) {
        let wordReq = "solicitações";
        let wordPend = "pendentes";
        if (pendingAnalysis == 1) {
          wordReq = "solicitação";
          wordPend = "pendente";
        }
        this.Notifications.push({
          Category: "Solicitações de Cadastro de Partner",
          Description: `Há ${pendingAnalysis} ${wordReq} de cadastro de Partner ${wordPend}. Clique nessa notificação para verificar as pendências.`,
          Icon: "how_to_reg",
          Link: "/deals/partners?listPending=true",
          IsRead: false,
          IsPermanent: true,
        });
      }
    },
    CheckPendingPartnerDoc: function (pendingAnalysis) {
      if (
        !this.$isAuthorize("PartnerDoc", "List") ||
        !this.$isAuthorize("PartnerDoc", "UpdateStatus")
      )
        return;
      if (pendingAnalysis != null && pendingAnalysis > 0) {
        let wordReq = "documentos de parceiros";
        let wordPend = "pendentes";
        if (pendingAnalysis == 1) {
          wordReq = "documento de parceiro";
          wordPend = "pendente";
        }
        this.Notifications.push({
          Category: "Documentos de Parceiros",
          Description: `Há ${pendingAnalysis} ${wordReq} ${wordPend} de aprovação. Clique nessa notificação para verificar as pendências.`,
          Icon: "grading",
          Link: "/relationship/partner-docs?listPending=true",
          IsRead: false,
          IsPermanent: true,
        });
      }
    },
    CheckPendingNoteExtractPartner: function (pendingAnalysis) {
      if (
        !this.$isAuthorize("NoteExtractPartner", "List") ||
        !this.$isAuthorize("NoteExtractPartner", "UpdateStatus")
      )
        return;
      if (pendingAnalysis != null && pendingAnalysis > 0) {
        let wordReq = "notas de serviço de parceiros";
        let wordPend = "pendentes";
        if (pendingAnalysis == 1) {
          wordReq = "nota de serviço de parceiro";
          wordPend = "pendente";
        }
        this.Notifications.push({
          Category: "Notas de Serviço de Parceiros",
          Description: `Há ${pendingAnalysis} ${wordReq} ${wordPend} de aprovação. Clique nessa notificação para verificar as pendências.`,
          Icon: "request_quote",
          Link: "/financial/note-extract-partners?listPending=true",
          IsRead: false,
          IsPermanent: true,
        });
      }
    },
    CheckPendingPartnerSolicitationContract: function (pendingAnalysis) {
      if (!this.$isAuthorize("Partner", "List")) return;
      if (pendingAnalysis != null && pendingAnalysis > 0) {
        let wordReq = "contratos de parceiros";
        let wordPend = "pendentes";
        if (pendingAnalysis == 1) {
          wordReq = "contrato de parceiro";
          wordPend = "pendente";
        }
        this.Notifications.push({
          Category: "Contratos de Parceiros",
          Description: `Há ${pendingAnalysis} ${wordReq} ${wordPend} de solicitação. Clique nessa notificação para verificar as pendências.`,
          Icon: "description",
          Link: "/deals/partners?listPendingAcceptedContract=true",
          IsRead: false,
          IsPermanent: true,
        });
      }
    },
    CheckPendingPartnerSignedContract: function (pendingAnalysis) {
      if (!this.$isAuthorize("Partner", "ListPartnerContract")) return;
      if (pendingAnalysis != null && pendingAnalysis > 0) {
        let wordReq = "contratos de parceiros";
        let wordPend = "pendentes";
        if (pendingAnalysis == 1) {
          wordReq = "contrato de parceiro";
          wordPend = "pendente";
        }
        this.Notifications.push({
          Category: "Assinaturas de Contratos de Parceiros",
          Description: `Há ${pendingAnalysis} ${wordReq} ${wordPend} de assinatura. Clique nessa notificação para verificar as pendências.`,
          Icon: "border_color",
          Link:
            "/relationship/partner-contracts?listPendingSignedContract=true",
          IsRead: false,
          IsPermanent: true,
        });
      }
    },
    CheckPartnerModifiedIdentity: function (pendingAnalysis) {
      if (!this.$isAuthorize("Partner", "List")) return;
      if (pendingAnalysis != null && pendingAnalysis > 0) {
        let wordReq = "parceiros";
        let wordPend = "que alteraram o CPF/CNPJ e estão pendentes";
        if (pendingAnalysis == 1) {
          wordReq = "parceiro";
          wordPend = "que alterou o CPF/CNPJ e está pendente";
        }
        this.Notifications.push({
          Category: "Atualização Contratual de Parceiros",
          Description: `Há ${pendingAnalysis} ${wordReq} ${wordPend} de atualização contratual. Clique nessa notificação para verificar as pendências.`,
          Icon: "person",
          Link: "/deals/partners?listModifiedIdentity=true",
          IsRead: false,
          IsPermanent: true,
        });
      }
    },
    CheckPendingMerchantSolicitationContract: function (pendingAnalysis) {
      if (!this.$isAuthorize("Merchant", "List")) return;
      if (pendingAnalysis != null && pendingAnalysis > 0) {
        let wordReq = "contratos de marketplaces";
        let wordPend = "pendentes";
        if (pendingAnalysis == 1) {
          wordReq = "contrato de marketplace";
          wordPend = "pendente";
        }
        this.Notifications.push({
          Category: "Contratos de Marketplaces",
          Description: `Há ${pendingAnalysis} ${wordReq} ${wordPend} de solicitação. Clique nessa notificação para verificar as pendências.`,
          Icon: "description",
          Link: "/deals/clients?listPendingAcceptedContract=true",
          IsRead: false,
          IsPermanent: true,
        });
      }
    },
    CheckPendingMerchantSignedContract: function (pendingAnalysis) {
      if (!this.$isAuthorize("Merchant", "ListMerchantContract")) return;
      if (pendingAnalysis != null && pendingAnalysis > 0) {
        let wordReq = "contratos de marketplaces";
        let wordPend = "pendentes";
        if (pendingAnalysis == 1) {
          wordReq = "contrato de marketplace";
          wordPend = "pendente";
        }
        this.Notifications.push({
          Category: "Assinaturas de Contratos de Marketplaces",
          Description: `Há ${pendingAnalysis} ${wordReq} ${wordPend} de assinatura. Clique nessa notificação para verificar as pendências.`,
          Icon: "border_color",
          Link:
            "/relationship/merchant-contracts?listPendingSignedContract=true",
          IsRead: false,
          IsPermanent: true,
        });
      }
    },
    CheckChangeManagement: function (count) {
      if (!this.$isAuthorize("ChangeManagement", "List")) return;
      if (count != null && count > 0) {
        let wordReq = "mudanças criadas";
        let wordReq2 = "las";
        if (count == 1) {
          wordReq = "mudança criada";
          wordReq2 = "la";
        }
        // this.Notifications.push({
        //   Category: "Gerenciamento de Mudanças",
        //   Description: `Há ${count} ${wordReq}. Clique nessa notificação para verificá-${wordReq2}.`,
        //   Icon: "border_color",
        //   Link: "/administration/change-management?listPending=true",
        //   IsRead: false,
        //   IsPermanent: true,
        // });
      }
    },
    CheckAlertaMerchant: function (count) {
       if (!this.$isAuthorize("AlertaMerchant", "Listar")) return;
      if (count != null && count > 0) {
        let wordReq = "alertas OFAC/PEP";
        let wordPend = "pendentes";
        if (count == 1) {
          wordReq = "alerta OFAC/PEP";
          wordPend = "pendente";
        }
        this.Notifications.push({
          Category: "Alertas OFAC/PEP",
          Description: `Há ${count} ${wordReq} ${wordPend} de liberação. Clique nessa notificação para verificar as pendências.`,
          Icon: "description",
          Link: "/compliance/alertas-merchant",
          IsRead: false,
          IsPermanent: true,
        });
      }
    },
    GetUserData: function () {
      if (this.$getUserInternal()) this.User = this.$getUserInternal();

      if (!this.User.PictureUrl)
        this.User.PictureUrl = require("@/assets/images/avatars/user.png");
      else this.User.PictureUrl = this.User.PictureUrl + `?${Math.random()}`;

      if (!this.User.Name) this.User.Name = "Usuário Safe2Pay";
      if (!this.User.Email) this.User.Email = "usuario@safe2pay.com.br";

      this.ComponentKey += 1;
    },
    Logoff: function () {
      this.loginOut = true;
      this.$store
        .dispatch("Logoff", { token: this.$getTokenAuth() })
        .then(() => {
          this.$router.push({
            name: "login",
            query: { info: "sessionFinished" },
          });
          this.$removeAuth();
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível encerrar sua sessão",
            "danger",
            "Saindo do sistema...",
            error
          );
        })
        .finally(() => {
          this.loginOut = false;
        });
    },
    MarkAllAsReaded() {
      this.Notifications.forEach((notification) => {
        if (notification.IsRead == false) {
          notification.IsRead = true;
          sessionStorage.setItem("NotificationIsReaded", true);
        }
      });
    },
    ToggleDropdown(id) {
      this.$root.$emit("bv::toggle::collapse", id);
    },
  },
};
</script>

<style>
.user-avatar {
  vertical-align: bottom;
}
.no-select {
  user-select: none;
}
#imgUserNav {
  width: 40px;
  height: 40px;
}
.collapsing {
  transition: height 0.45s !important;
  display: block;
}
.user-name {
  font-weight: 600;
}
.company-name {
  font-size: 9pt;
  font-weight: 100;
}
.nav-link:hover {
  cursor: pointer;
}
/* IE11 Navbar flex fix. */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .navbar-nav {
    align-items: stretch !important;
    flex: 1 1 100%;
    flex-flow: row wrap;
  }
  .nav-item.notifications {
    margin-left: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/MainNavbar/NavbarNav.vue